import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Renderer2,
  ChangeDetectorRef,
} from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { MatDialog } from '@angular/material/dialog';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { LoggingService } from 'src/app/services/consoleLogs';
import { BaseServicesService } from 'src/app/services/base-services/base-services.service';
import { MessageService } from 'primeng/api';
import { NavigationEnd, Router } from '@angular/router';
import { DoctorProfile } from 'src/app/models/profile.model';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { filter } from 'rxjs';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { TenantUIResponse } from 'src/app/models/tenant.model';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  animations: [
    trigger('imagePopup', [
      state('void', style({ opacity: 0, transform: 'scale(0.8)' })),
      transition('void => *', [animate('0.3s ease-in-out')]),
      transition('* => void', [
        animate(
          '0.3s ease-in-out',
          style({ opacity: 0, transform: 'scale(0.8)' })
        ),
      ]),
    ]),
    trigger('overlayAnimation', [
      state('void', style({ opacity: 0 })),
      transition(':enter, :leave', [
        animate('200ms ease-in-out')
      ])
    ]),

    trigger('dialogAnimation', [
      state('void', style({ transform: 'scale(0.9)', opacity: 0 })),
      transition(':enter', [
        animate('200ms ease-out', style({ transform: 'scale(1)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('150ms ease-in', style({ transform: 'scale(0.9)', opacity: 0 }))
      ])
    ])

  ],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit, AfterViewInit {
  logoPath: string | null = null;
  showProfileDialog: boolean = false;
  editableName: string = '';
  showChangePassword: boolean = false;
  currentPassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  isProcessing: boolean = false;
  profileForm: any;
  email: string | null = null;
  profileError: string = '';
  passwordError: string = '';
  passwordSuccess: string = '';



  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();
  profileData: DoctorProfile | undefined;

  passwordErrors = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  };
  avatarList: string[] = [
    '../../../../assets/images/profile/user-1.jpg',
    '../../../../assets/images/profile/user-2.jpg',
    '../../../../assets/images/profile/user-3.jpg',
    '../../../../assets/images/profile/user-4.jpg',

    // ...add paths for 10 avatars
  ];
  selectedAvatar!: string;
  imageUrl = this.avatarList[0];
  showAvatarList = false;
  isEditingAvatar = false;
  showFiller = false;
  visible: boolean = false;
  isDropdownVisible: boolean = false;
  enlargedImageVisible = false;
  activeIndex: number = 1;
  isUploading = false;
  profileName: string = '';
  selectedImageUrl: string | ArrayBuffer | null = null;
  selectedImageVisible: boolean = false;
  profilePicUrl: string = '';
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('blurDialog') blurDialog!: ElementRef;
  isModulePage: boolean = false;
  defaultImageUrl = '../../../../assets/images/logos/NoProfile.jpg';
  uploadName: boolean = false;
  logoWidth = '100';
  logoHeight = '50';
  logoAlt = 'Logo';
  loginPath: string = '';
  loading: boolean = true;
  tenantUI!: TenantUIResponse;
  userDetails: any;
  userEmail: any;
  passwordForm!: FormGroup;
private alertTimeout: any;


  constructor(
    public dialog: MatDialog,
    private router: Router,
    private baseServicesService: BaseServicesService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private renderer: Renderer2,
    private loggingService: LoggingService,
    private location: Location,
    private cd: ChangeDetectorRef
  ) {
    this.initializePasswordForm();

    this.baseServicesService.profilePicUrl$.subscribe((url) => {
      this.profilePicUrl = url; // Update profilePicUrl dynamically
    });
    this.baseServicesService.profileName$.subscribe((name) => {
      this.profileName = name;
    });
    this.profileForm = this.fb.group({
      name: [this.profileName, Validators.required],
    });
  }


  ngAfterViewInit(): void {
    // Apply styles only when the dialog is visible
    if (this.uploadName) {
      const dialogMask =
        this.blurDialog.nativeElement.closest('.p-dialog-mask');
      if (dialogMask) {
        this.renderer.setStyle(dialogMask, 'backdrop-filter', 'blur(8px)');
        this.renderer.setStyle(
          dialogMask,
          'background-color',
          'rgba(255, 255, 255, 0.6)'
        );
      }
    }
  }

  

  onImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = this.defaultImageUrl; // Fallback to default image
  }
  ngOnInit(): void {
    this.loadTenantBranding();
    this.loadTenantUI();
    this.loadUserDetails();
  }

  private initializePasswordForm(): void {
    this.passwordForm = this.fb.group({
      currentPassword: ['', [Validators.required, Validators.minLength(6)]],
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]]
    }, {
      validators: this.passwordMatchValidator
    });
  }

  // Custom validator to check if new password and confirm password match
  private passwordMatchValidator(form: FormGroup): { [key: string]: boolean } | null {
    const newPassword = form.get('newPassword')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;

    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      return { 'passwordMismatch': true };
    }
    return null;
  }


  // Handle form submission
  onChangePassword(): void {
    if (this.passwordForm.invalid) {
      this.markFormGroupTouched(this.passwordForm);
      return;
    }

    // Clear previous errors
    this.clearPasswordError();
    this.clearPasswordSuccess();

    this.isProcessing = true;

    const formValue = this.passwordForm.value;

    this.baseServicesService.changePassword(
      formValue.currentPassword,
      formValue.newPassword,
      formValue.confirmPassword
    ).subscribe({
      next: (response) => {
        this.isProcessing = false;
        
        // Show success message in the popup
        this.passwordSuccess = response.message || 'Password changed successfully!';
        
        // Auto-clear success message after 3 seconds
        setTimeout(() => {
          this.clearPasswordSuccess();
          this.disablePasswordChange();
        }, 3000);
      },
      error: (error) => {
        this.isProcessing = false;
        this.loggingService.error('Password change error:', error);

        // Show error message in the popup
        this.passwordError = error.error?.message || 'Failed to change password. Please try again.';
      }
    });
  }

  // Error handling methods
  clearProfileError(): void {
    this.profileError = '';
  }

  clearPasswordError(): void {
    this.passwordError = '';
  }

  clearPasswordSuccess(): void {
    this.passwordSuccess = '';
  }

  disablePasswordChange(): void {
    this.showChangePassword = false;
    this.passwordForm.reset();
    this.clearPasswordError();
    this.clearPasswordSuccess();
    this.isProcessing = false;
  }

  closeProfileDialog(): void {
    this.showProfileDialog = false;
    this.showChangePassword = false;
    this.isProcessing = false;
    this.passwordForm.reset();
    this.clearProfileError();
    this.clearPasswordError();
    this.clearPasswordSuccess();
  }

  enablePasswordChange(): void {
    this.showChangePassword = true;
    this.passwordForm.reset();
    this.clearPasswordError();
    this.clearPasswordSuccess();
  }



  // Helper method to mark all form controls as touched
  private markFormGroupTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormControl) {
        control.markAsTouched();
      } else if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  // Getter methods for easy access to form controls in template
  get currentPasswordControl(): FormControl {
    return this.passwordForm.get('currentPassword') as FormControl;
  }

  get newPasswordControl(): FormControl {
    return this.passwordForm.get('newPassword') as FormControl;
  }

  get confirmPasswordControl(): FormControl {
    return this.passwordForm.get('confirmPassword') as FormControl;
  }



  loadUserDetails() {
    this.baseServicesService.getUserDetailsById().subscribe({
      next: (res) => {
        this.loggingService.log("User Details:", res);
        this.userDetails = res?.data;
      },
      error: (err) => {
        this.loggingService.error("Error fetching user details:", err);
      }
    });
  }


  openProfileDialog() {
    this.editableName = this.userDetails?.name || '';
    this.userEmail = this.userDetails?.email || '';
    this.showChangePassword = false;
    this.resetPasswordFields();
    this.showProfileDialog = true;

    setTimeout(() => {
      this.cd.detectChanges();
    });
  }




  // // Updated component methods
  // enablePasswordChange() {
  //   this.showChangePassword = true;
  //   // Clear any existing password fields when switching to password mode
  //   this.currentPassword = '';
  //   this.newPassword = '';
  //   this.confirmPassword = '';
  // }

  // disablePasswordChange() {
  //   this.showChangePassword = false;
  //   // Clear password fields when going back to profile mode
  //   this.resetPasswordFields();
  // }

  cancelProfileEdit() {
    this.showProfileDialog = false;
    this.showChangePassword = false;
    this.resetPasswordFields();
  }

  // closeProfileDialog(): void {
  //   this.showProfileDialog = false;
  //   this.showChangePassword = false;
  //   this.isProcessing = false;
  //   this.passwordForm.reset();
  // }

  saveProfileChanges(): void {
  if (this.isProcessing || !this.isFormValid()) return;

  this.isProcessing = true;

  this.baseServicesService.updateProfile(this.editableName).subscribe({
    next: (response) => {
      this.isProcessing = false;

      // 🔥 Update UI dynamically
      this.userDetails.name = this.editableName;

      this.messageService.add({
        key: 'confirm',
        severity: 'success',
        summary: 'Success',
        detail: 'Profile updated successfully!'
      });

      this.closeProfileDialog();
    },
    error: (error) => {
      this.isProcessing = false;

      this.messageService.add({
        key: 'confirm',
        severity: 'error',
        summary: 'Error',
        detail: error.error?.message || 'Failed to update profile'
      });
    }
  });
}


  updateProfile() {
    const updateData = {
      name: this.editableName
    };

    // this.baseServicesService.updateUserDetails(updateData).subscribe({
    //   next: (res) => {
    //     this.loggingService.log("Profile updated successfully:", res);
    //     this.userDetails.name = this.editableName;
    //     this.showProfileDialog = false;
    //     this.isProcessing = false;
    //     // Show success message
    //   },
    //   error: (err) => {
    //     this.loggingService.error("Error updating profile:", err);
    //     this.isProcessing = false;
    //     // Show error message
    //   }
    // });
  }

  updatePassword() {
    const passwordData = {
      currentPassword: this.currentPassword,
      newPassword: this.newPassword
    };

    // this.baseServicesService.changePassword(passwordData).subscribe({
    //   next: (res) => {
    //     this.loggingService.log("Password updated successfully:", res);
    //     this.showProfileDialog = false;
    //     this.showChangePassword = false;
    //     this.resetPasswordFields();
    //     this.isProcessing = false;
    //     // Show success message
    //   },
    //   error: (err) => {
    //     this.loggingService.error("Error updating password:", err);
    //     this.isProcessing = false;
    //     // Show error message
    //   }
    // });
  }

  isFormValid(): boolean {
    if (this.showChangePassword) {
      // Password change validation
      if (!this.currentPassword || !this.newPassword || !this.confirmPassword) {
        return false;
      }

      if (this.newPassword !== this.confirmPassword) {
        return false;
      }

      if (this.newPassword.length < 8) {
        return false;
      }

      // Optional: Check if new password is different from current
      if (this.currentPassword === this.newPassword) {
        return false;
      }
    } else {
      // Profile update validation - name is required
      if (!this.editableName.trim()) {
        return false;
      }
    }

    return true;
  }

  resetPasswordFields() {
    this.currentPassword = '';
    this.newPassword = '';
    this.confirmPassword = '';
  }

  // Keep your existing methods for image handling
  triggerImageUpload() {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  onImageSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.uploadProfileImage(file);
    }
  }

  uploadProfileImage(file: File) {
    // Your image upload implementation
    this.loggingService.log("Uploading image:", file);
  }


  private loadTenantUI(): void {
    this.loading = true;
    this.baseServicesService.getTenantUI().subscribe({
      next: (data: TenantUIResponse) => {
        this.tenantUI = data;
        this.loggingService.log("Fresh tenantUI from API", this.tenantUI);
        localStorage.setItem('tenantUI', JSON.stringify(data));
        this.applyTenantUI(data);
        this.loading = false;
      },
      error: (err) => {
        this.loggingService.error('Error fetching tenant UI from API:', err);
        const cachedData = localStorage.getItem('tenantUI');
        if (cachedData) {
          this.loggingService.log("Falling back to cached tenantUI", cachedData);
          this.applyTenantUI(JSON.parse(cachedData));
        }
        this.loading = false;
      }
    });
  }

  private applyTenantUI(data: TenantUIResponse): void {
    const branding = data.data.portalConfig.branding;
    document.documentElement.style.setProperty('--brand-color', branding.brandColor);
    document.documentElement.style.setProperty('--secondary-color', branding.secondaryColor);
    if (branding.logo?.url) {
      this.loginPath = branding.logo.url;
    }
  }


  private loadTenantBranding(): void {
    const cachedData = localStorage.getItem('tenantUI');
    if (!cachedData) return;

    try {
      const tenantUI = JSON.parse(cachedData);
      const branding = tenantUI?.data?.portalConfig?.branding;

      if (branding?.logo) {
        this.logoPath = branding.logo.url || '';
        this.logoWidth = branding.logo.width || '100';
        this.logoHeight = branding.logo.height || '50';
        this.logoAlt = branding.logo.alt || 'Logo';

        this.loggingService.log("this.logoHeight", this.logoHeight);
      }
    } catch (e) {
      this.loggingService.error('Error parsing tenantUI from localStorage', e);
    }


    // === your existing token logic ===
    this.checkModulePage(this.router.url);
    const token = localStorage.getItem('authToken');

    if (token) {
      this.loggingService.log('Raw token:===>', token);

      const parts = token.split('.');
      if (parts.length === 3) {
        const payload = JSON.parse(atob(parts[1]));
        this.loggingService.log('Decoded payload:', payload);
        this.email = payload.email;
      } else {
        this.loggingService.error('Invalid token structure.');
      }
    } else {
      this.loggingService.log('No token found in session storage.');
    }

    this.loggingService.log('Email:', this.email);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const navigationEvent = event as NavigationEnd;
        this.checkModulePage(navigationEvent.url);
        this.loggingService.log(`Navigation URL: ${navigationEvent.url}`);
        this.loggingService.log(`isModulePage: ${this.isModulePage}`);
      });
  }


  goBack(): void {
    this.location.back(); // Navigate to the previous screen
  }

  checkModulePage(url: string): void {
    this.isModulePage = url.includes('/lms/admin/news'); // Adjust this to match your specific route
  }

  logout(): void {
    this.router.navigate(['/']);
    localStorage.removeItem('authToken');
  }

  private fetchProfile(): void {
    this.baseServicesService.getProfile().subscribe(
      (data: DoctorProfile) => {
        this.profileData = data;
        this.profilePicUrl = data.data.profilePic || this.profilePicUrl;
        this.profileName = data.data.name || this.profileName;
      },
      (error) => {
        this.loggingService.error('Error fetching profile data:', error);
      }
    );
  }
  redirectToChangePassword() {
    this.router.navigate(['/ChangePassword'], {
      queryParams: { origin: 'header' },
    });
  }
  triggerFileInput() {
    if (this.fileInput) {
      this.loggingService.log('triggerFileInput called');
      this.fileInput.nativeElement.click();
    } else {
      this.loggingService.log('fileInput not found');
    }
  }
  updateNameDialog() {
    this.uploadName = true;
  }
  updateName() {
    this.uploadName = true;
    const updatedName = this.profileForm.get('name')?.value;
    this.loggingService.log('Updated Name:', updatedName);

    if (this.profileForm.valid) {
      const { name } = this.profileForm.value;

      this.baseServicesService.updateProfile(name).subscribe({
        next: (response) => {
          this.loggingService.log('Profile updated successfully:', response);
          this.uploadName = false; // Close the dialog on success

          // Show success toast
          this.messageService.add({
            key: 'confirm',
            severity: 'success',
            summary: 'Success',
            detail: 'Profile updated successfully!',
          });
        },
        error: (error) => {
          this.loggingService.error('Error updating profile:', error);
          this.uploadName = false; // Stop loading indicator

          // Show error toast
          this.messageService.add({
            key: 'confirm',
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update profile.',
          });
        },
      });
    }
  }
  onFileSelected(event: Event): void {
    this.loggingService.log('loggedd');
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.selectedImageUrl = e.target?.result || null;
        this.selectedImageVisible = true;
      };
      reader.readAsDataURL(input.files[0]);
    }
  }
  uploadSelectedImage(event: Event): void {
    event.stopPropagation();

    if (typeof this.selectedImageUrl === 'string') {
      this.isUploading = true;

      this.loadImageAsFile(this.selectedImageUrl)
        .then((file: File) => {
          this.baseServicesService.updateProfilePic(file).subscribe({
            next: (response) => {
              this.loggingService.log(
                'Profile picture updated successfully',
                response
              );
              this.isUploading = false;

              this.messageService.add({
                key: 'confirm',
                severity: 'success',
                summary: 'Upload Successful',
                detail: 'Your profile picture has been updated successfully.',
                life: 3000,
              });

              // Set the profilePicUrl to the new selected image URL if it’s a string
              if (typeof this.selectedImageUrl === 'string') {
                this.profilePicUrl = this.selectedImageUrl;
              }
              this.selectedImageVisible = false;
            },
            error: (error) => {
              this.loggingService.error(
                'Error updating profile picture',
                error
              );
              this.isUploading = false;

              this.messageService.add({
                key: 'confirm',
                severity: 'error',
                summary: 'Upload Failed',
                detail: 'There was an error updating your profile picture.',
              });
            },
          });
        })
        .catch((err) => {
          this.loggingService.error(
            'Error converting image URL to File object',
            err
          );
          this.isUploading = false;

          this.messageService.add({
            key: 'confirm',
            severity: 'error',
            summary: 'Upload Failed',
            detail: 'There was an error processing the selected image.',
          });
        });
    } else {
      this.loggingService.error('Selected image is not a valid URL string.');
    }
  }

  closeSelectedImage(): void {
    this.selectedImageVisible = false;
  }

  showDialog() {
    this.visible = true;
  }

  showEnlargedImage(): void {
    this.enlargedImageVisible = true;
    this.loggingService.log('click');
  }
  closeEnlargedImage(): void {
    this.enlargedImageVisible = false;
  }
  toggleDropdown() {
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  addPhoto() {
    if (this.fileInput) {
      this.loggingService.log('triggerFileInput called');
      this.fileInput.nativeElement.click();
      this.isDropdownVisible = false;
    } else {
      this.loggingService.log('fileInput not found');
    }
  }
  handleFileInput(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.loggingService.log('Selected file:', file);
    }
  }
  saveSelectedAvatar() {
    this.loggingService.log('Avatar saved:', this.imageUrl);
    this.visible = false;
  }

  onDialogHide() {
    this.imageUrl = '../../../../assets/images/profile/user-1.jpg'; // Reset to default
  }

  editAvatar() {
    this.showAvatarList = true;
    this.isDropdownVisible = false;
  }

  getLeftIndex() {
    return this.activeIndex === 0
      ? this.avatarList.length - 1
      : this.activeIndex - 1;
  }

  getRightIndex() {
    return (this.activeIndex + 1) % this.avatarList.length;
  }

  nextAvatar() {
    this.activeIndex = (this.activeIndex + 1) % this.avatarList.length;
  }

  previousAvatar() {
    this.activeIndex =
      this.activeIndex === 0
        ? this.avatarList.length - 1
        : this.activeIndex - 1;
  }
  previousImage(event: Event): void {
    event.stopPropagation();
    if (this.activeIndex > 0) {
      this.activeIndex--;
    }
  }
  nextImage(event: MouseEvent) {
    event.stopPropagation();
    if (this.activeIndex < this.avatarList.length - 1) {
      this.activeIndex++;
    }
  }
  getTransform(): string {
    return `translateX(-${this.activeIndex * 100}%)`;
  }

  confirmSelection() {
    this.loggingService.log('Selected Avatar:', this.selectedAvatar);
    this.showAvatarList = false;
  }

  closeOverlay(): void {
    this.enlargedImageVisible = false;
    this.showAvatarList = true;
    this.loggingService.log('closeOverlay');
  }
  closeAvatarList(): void {
    this.showAvatarList = false;
  }
  onReject() {
    this.messageService.clear('confirm');
  }
  selectAvatar(avatar: string): void {
    this.loggingService.log('Clicked');
    this.imageUrl = avatar;
    this.showAvatarList = false;
    this.isUploading = true;
    this.loggingService.log('thisImage', this.imageUrl);

    // Convert avatar URL to File and update profile picture
    this.loadImageAsFile(avatar).then((file: File) => {
      this.baseServicesService.updateProfilePic(file).subscribe({
        next: (response) => {
          this.loggingService.log(
            'Profile picture updated successfully',
            response
          );
          this.isUploading = false;

          // Update profilePicUrl to reflect new avatar in dialog
          this.profilePicUrl = avatar;

          this.messageService.add({
            key: 'confirm',
            severity: 'success',
            summary: 'Upload Successful',
            detail: 'Your profile picture has been updated successfully.',
            life: 3000,
          });
        },
        error: (error) => {
          this.loggingService.error('Error updating profile picture', error);
          this.isUploading = false;
          this.messageService.add({
            key: 'confirm',
            severity: 'error',
            summary: 'Upload Failed',
            detail: 'There was an error updating your profile picture.',
            life: 3000,
          });
        },
      });
    });
  }

  private loadImageAsFile(url: string): Promise<File> {
    return new Promise((resolve, reject) => {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const file = new File([blob], 'profilePic.jpg', { type: blob.type });
          resolve(file);
        })
        .catch((err) => reject(err));
    });
  }

  toggleSidebar(): void {
    // Logic to open/close the sidebar
    this.loggingService.log('Sidebar toggled');
  }


}
